//@flow
import { EditMetadataMsg, EditMetadataQuery, RepoItem, EditMetadataRes } from '../../autogenerated/ZoomBridge';
import ErrorHandler from '../../error/ErrorHandler';
import GetMetadata from './GetMetadata';
import AssetListCache from '../asset/AssetListCache';
import { BREADCRUMB_ASSETS } from '../../store/Constants';
import Store from '../../store/Store';
import ErrorId from '../../protocol/ErrorId';
import _ from 'lodash';

export default class EditMetadata {
  _assetCache: AssetListCache;
  repoItems: Array<RepoItem>;
  msg: EditMetadataMsg;

  constructor(msg: EditMetadataMsg, repoItems: Array<RepoItem> = [], fromComponent: string) {
    this.msg = msg;
    this._assetCache = AssetListCache.getInstance();
    this.repoItems = repoItems;
    this.fromComponent = fromComponent;
  }

  run(): Promise<EditMetadataRes> {
    return new Promise((onSuccess, onFailure) => {
      const query: EditMetadataQuery = new EditMetadataQuery();
      query.message = this.msg;
      query.run().then(
        (resp: EditMetadataRes) => {
          if (_.size(this.repoItems) > 0) this.updateMetadataInCache();
          onSuccess(resp);
        },
        (error: ErrorId) => {
          ErrorHandler.handleError(error);
          onFailure(error);
        }
      );
    });
  }

  updateMetadataInCache() {
    new GetMetadata(this.msg.getAssetsInfo()).run().then(
      (resp) => {
        const __fuid2MetadataMap = resp.getFuid2MetadataMap();
        const breadCrumbAssets: RepoItem[] = Store.get(BREADCRUMB_ASSETS);
        let childAssets;
        if (breadCrumbAssets.length) {
          const selectedFolder = breadCrumbAssets[breadCrumbAssets.length - 1].getFuid();
          childAssets = this._assetCache.rootFuidToRepoItems.get(selectedFolder);
        } else {
          childAssets = this.getChildAssets();
        }
        for (let asset of this.msg.getAssetsInfo()) {
          const childAsset = childAssets.get(asset.getFuid());
          if (childAsset !== undefined) {
            const metadataMapObject = __fuid2MetadataMap.get(asset.getFuid());
            if (metadataMapObject !== undefined) {
              if (this.fromComponent == 'editModal') {
                // const fuid = asset.getFuid();
                const metaObject = this.getMetadataObject(
                  metadataMapObject.getProperties(),
                  //  childAssets.get(fuid).getMetadataMap()
                  childAsset.getMetadataMap()
                );
                childAsset.setMetadataMap(metaObject);
              } else childAsset.setMetadataMap(metadataMapObject.getProperties());
            }
          }
        }
        window.render();
      },
      (error) => {
        ErrorHandler.handleError(error);
      }
    );
  }
  getMetadataObject(metadataMapObject, metaData) {
    const assetInfoColName = [
      'FIPR_File Size',
      '"FIPR_Revision Size',
      'FIPR_File Path',
      'FIPR_Repo Revision',
      'FIPR_Author',
      'FIPR_Comment',
      'FIPR_Asset ID'
    ];
    metaData.forEach((key, val) => {
      if (assetInfoColName.includes(key)) {
        metadataMapObject.put(key, val);
      }
    });
    return metadataMapObject;
  }
  getChildAssets() {
    let fuidToRepoItems: ?Map<number, RepoItem> = new Map();
    for (let asset of this.repoItems) {
      const repoItem = asset;
      const fuid: number = asset.getFuid();
      fuidToRepoItems.set(fuid, repoItem);
    }
    return fuidToRepoItems;
  }
}
